<template>
  <page-outline :title="$t('pacs008.process_SCT')">
    <template slot="pageContent">
      <!-- FILTRES MOBILE -->
      <div v-if="isSmartphoneOS" slot="fixed">
        <div style="position: absolute; top: 44px; width: 100%">
          <cm-messages-filter
            class="researchfilter"
            style="position: relative; z-index: 10"
            propedServiceId="10"
            filterType="list"
            :mode="this.mode"
            @applyFilter="applyFilter($event)">
          </cm-messages-filter>
        </div>
      </div>

      <div class="listPage" style="overflow: hidden">
        <b-row>
          <b-col cols="12">
            <div class="requestsList">
              <div v-if="!isSmartphoneOS">
                <cm-messages-filter
                  class="researchfilter"
                  style="position: relative; z-index: 10"
                  filterType="list"
                  format="SCT"
                  :mode="this.mode"
                  :randomId="randomId"
                  @applyFilter="applyFilter($event)"
                  propedServiceId="10"
                  :countResults="paginationObject.nbResultsTotal.toString()">
                </cm-messages-filter>
              </div>
              <div v-if="isSmartphoneOS" :style="customMobileLayoutStyle"></div>
            </div>

            <br />

            <b-row class="justify-content-center">
              <b-col sm="12">
                <hr class="w-100" />
              </b-col>
            </b-row>

            <br />
            <spinner v-if="activateSpinner"></spinner>
            <div v-else>
              <b-table
                hover
                responsive
                v-if="items.length"
                class="mt-3"
                :items="items"
                :fields="fields"
                :sort-by.sync="sortBy"
                :sort-desc.sync="sortDir"
                @head-clicked="sortTable">
                <template #cell(protocol)="data">
                  <div class="text-center">
                    <i v-if="data.value === 'webservice'" class="fa-solid fa-globe" :title="data.value"></i>
                    <i v-if="data.value === 'remote folder'" class="fa-solid fa-folder-arrow-up" :title="data.value"></i>
                    <i v-if="data.value === 'interface'" class="fa-solid fa-file-arrow-up" :title="data.value"></i>
                  </div>
                </template>
                <template #cell(statut)="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis" :title="data.value">
                    <span :title="data.value" :class="data.item.statusClass">{{ data.value }}</span>
                  </div>
                </template>
                <template #cell(msgIdd)="data">
                  <div v-if="data.item.statut === 'Accepté' || data.item.statut === 'Accepted'" class="text-center" style="overflow: hidden; text-overflow: ellipsis" :title="data.value">
                    <span class="text-link-purple" :title="data.value" @click="redirectToTransactions(data.value)">{{ data.value }}</span>
                  </div>
                  <div v-else class="text-center" style="overflow: hidden; text-overflow: ellipsis" :title="data.value">
                    <span class="text-link-purple" style="cursor: default" :title="data.value">{{ data.value }}</span>
                  </div>
                </template>
                <template #cell()="data">
                  <div class="text-center" style="overflow: hidden; text-overflow: ellipsis">
                    <span :title="data.value">{{ data.value }}</span>
                  </div>
                </template>
                <!-- <template #cell(status)="row_s"><div class="text-left">{{ row_s.item.status}}</div></template> -->
              </b-table>
              <div v-else class="d-flex justify-content-center">
                <span class="noResult">
                  {{ $t('common.no_result') }}
                </span>
              </div>
            </div>

            <b-row class="justify-content-end mt-5">
              <b-col lg="2" offset="7" class="mt-3">
                <b-button variant="primary"
                  @click="exportList()">
                  <i class="fa-solid fa-arrow-up-from-bracket"></i>
                  {{ $t('pain008.extract_list') }}
                </b-button>
              </b-col>
            </b-row>

            <b-row class="mt-5">
              <b-col>
                <cm-pagination
                  :maxResultsByPage="paginationObject.maxResults"
                  :firstIndex="paginationObject.firstIndex"
                  :nbResultsTotal="paginationObject.nbResultsTotal"
                  :refreshEvent="paginationObject.refresh">
                </cm-pagination>
              </b-col>
            </b-row>
          </b-col>
        </b-row>
      </div>
    </template>
  </page-outline>
</template>
<script>
import moment from "moment"
import PageOutline from "@/components/common/PageOutline.vue"
import Spinner from "@/components/common/spinner.vue"
import pagination from "@/components/common/pagination.vue"
import MessagesFilter from "@/pages/pacs008/components/FilterEntry/index.vue"
import {errorMessageAlert} from '@/helpers/alert'
import {statusLabel} from '@/helpers/labels'
import {loadPage} from '@/helpers/routing'


export default {
  name: "Traitement",
  components: {
    'cm-messages-filter': MessagesFilter,
    'cm-pagination': pagination,
    'page-outline': PageOutline,
    'spinner': Spinner
  },
	props: {
		modeFilter: {
      default: '1',
      type: String
    }
	},
  computed: {
		isSmartphoneOS () {
      return this.$f7.device.os === 'android' || this.$f7.device.os === 'ios'
    },
	},
  data() {
    return {
      activateSpinner: false,
      completeList:[],
      countResults: '',
      fields: [
        {
          key: "processDate",
          label: this.$t("pacs008.process_date"),
          class: "text-center",
          sortable: true
        },
        {
          key: "protocol",
          label: this.$t("pacs008.protocole"),
          class: "text-center"
        },
        {
          key: "format",
          label: this.$t("pacs008.type_format"),
          class: "text-center"
        },
        {
          key: "msgIdd",
          label: this.$t("pacs008.msgId"),
          class: "text-center",
          sortable: true
        },
        {
          key: "statut",
          label: this.$t("pacs008.stat_global"),
          class: "text-center"
        },
        {
          key: "reasonDesc",
          label: this.$t("pacs008.reason_desc"),
          class: "text-center"
        },
        {
          key: "nameFileOut",
          label: this.$t("pacs008.name_pain002_out"),
          class: "text-center"
        }
      ],
      filterConditions: {},
      items: [],
      mode: 1,
      paginationObject: {},
      randomId: Math.random().toString(36).substr(2, 10),
      sortBy: '',
      sortDir: false,
      statusClass: {
        '1': 'text-success',
        '2': 'text-danger',
        '0': 'text-danger'
      }
    }
  },
  created() {
    if (this.filterConditions) {
      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }
   }

    this.reload = false
    // this.randomString = Math.random().toString(36).replace(/[^a-z]+/g, '').substr(0, 5)

    this.$bus.$emit('change-mobile-header', {
    backLink: false,
    navbarInnerStyle: 'justify-content: start',
    navTitle: this.listTitle,
    returnUrl: ''
  })

  this.paginationObject['firstIndex'] = 1
  this.paginationObject['maxResults'] = 13
  this.paginationObject['nbResultsTotal'] = 0

  this.paginationObject['refresh'] = 'traitement-page'
  this.$bus.$off('traitement-page')
  this.$bus.$on('traitement-page', index => {
    that.onRefresh(false, index)
    that.pageCounter = 0
  })

  let that = this
  // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
  // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

  // this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
  // this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage

  this.$f7.initPullToRefresh()
  this.pageCounter = 0
  this.onRefresh(false)
  },
  methods: {
    applyFilter (filterConditions, index = 1) {
      this.filterConditions = filterConditions

      this.reload = true
      if (filterConditions.modeFilter !== undefined && filterConditions.modeFilter !== this.mode) {
        this.mode = filterConditions.modeFilter
      }

      if (this.filterConditions.OrderByField) {
        this.sortBy = this.filterConditions.OrderByField
      }
     if (this.filterConditions.OrderByDirection) {
        this.sortDir = this.filterConditions.OrderByDirection === 'DESC'
      }

      this.pageCounter = 0
      this.paginationObject.firstIndex = index
      this.paginationObject.nbResultsTotal = 0

      this.activateSpinner = true
      this.$engine.pacs008.updateIn(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}
        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults
        this.paginationObject.nbResults = resp.data.Pacs008In.length
        requests = resp.data.Pacs008In
        this.updateItems(requests)
        this.updateInbox(requests)
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    exportList () {
      let filterConditions = {}
      if (this.reload) {
        filterConditions = this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
      }
      this.$engine.pacs008.getPacsInCsv(
        filterConditions
      ).then( resp => {
        let list = {}
        list = resp.data.ExportPacs008In
        this.updateList(list)
        this.extractCSV(this.completeList)
      }).catch(e => {
        errorMessageAlert(e, this, this.$i18n)
      })
    },
    extractCSV(completeList) {
      this.$f7.showPreloader(this.$i18n.t("common.loading_page_label"))
      let today = moment()
      let firstLine =
        this.$t("pacs008.process_date") + ";" +
        this.$t("pacs008.protocole") + ";" +
        this.$t("pacs008.type_format") + ";" +
        this.$t("pacs008.msgId") + ";" +
        this.$t("pacs008.stat_global") + ";" +
        this.$t("pacs008.reason_desc") + ";" +
        this.$t("pacs008.name_pain002_out") + "\r\n";
      let line = atob(this.completeList.data)
      let data = firstLine + line
      let linkSource = "data:text/csv;charset:utf-8;base64," + btoa(data)
      let downloadLink = document.createElement("a")
      let fileName = "Pacs008_" + today.unix() + ".csv"
      this.$f7.hidePreloader()

      downloadLink.href = linkSource
      downloadLink.download = fileName
      downloadLink.click()
    },
    onRefresh(noAttach = false, index = 1) {
      this.pageCounter = 0
      this.paginationObject.firstIndex = index
      this.paginationObject.nbResultsTotal = 0
      this.activateSpinner = true
      let filterConditions

      if (this.reload) {
        filterConditions = this.$engine.pacs008.filter.getConditionObject()
      } else {
        filterConditions = this.$engine.pacs008.filter.getDefaultFilter()
      }

      if (this.filterConditions.OrderByField) {
        filterConditions.OrderByField = this.filterConditions.OrderByField
      }
      if (this.filterConditions.OrderByDirection) {
        filterConditions.OrderByDirection = this.filterConditions.OrderByDirection
     }
      // let that = this

      this.$engine.pacs008.updateIn(
        this.paginationObject.maxResults,
        this.paginationObject.firstIndex,
        filterConditions
      ).then(resp => {
        let requests = {}

        this.paginationObject.nbResultsTotal = resp.data.nbTotalResults

        this.paginationObject.nbResults = resp.data.Pacs008In.length

        requests = resp.data.Pacs008In

        this.updateItems(requests)

        this.updateInbox(requests, noAttach)
        this.$f7.pullToRefreshDone()
        this.$bus.emit('refresh-cache-paging-template', this.paginationObject)
        this.activateSpinner = false
      })
      .catch(error => {
        this.activateSpinner = false
        errorMessageAlert(error, this, this.$i18n)
      })
    },
    redirectToTransactions (msgIdd) {
      this.$engine.pacs008.CurrentMsgIdSCT = msgIdd
      loadPage(this, {url: '/pacs008/SCT/transactions/' + msgIdd})
    },
    sortTable (key, field, event, isFooter) {
      let sortDirection = 'ASC'
      if (key === this.sortBy && this.sortDir === false) {
        sortDirection = 'DESC'
      }

      this.filterConditions.OrderByField = key
      this.filterConditions.OrderByDirection = sortDirection

      this.applyFilter(this.filterConditions, this.paginationObject.firstIndex)
    },
    updateInbox (requests, noAttach = false) {
      this.inboxMessages = requests
    },
    updateItems (requests) {
      this.items = []
      for (var i = 0; i < requests.length; i++) {

        let processDate = ''
        processDate = requests[i].processDate

        if (processDate !== '') {
          processDate = moment(processDate).format('DD/MM/YYYY [à] HH[h]mm')
        }

        let statusLibelle = ''
        let statusClass = ''
        if (requests[i].status != '') {
          statusLibelle = statusLabel(this.$i18n, "pacs008_" + requests[i].status)
          statusClass = this.statusClass[requests[i].status]
        } else {
          statusLibelle = '-'
        }

        let result = {
          processDate: processDate,
          format: requests[i].format,
          statut: statusLibelle,
          statusClass: statusClass,
          fileName: requests[i].fileName,
          msgIdd: requests[i].MsgId,
          protocol: requests[i].protocole,
          reasonDesc: requests[i].reasonDesc,
          nameFileOut: requests[i].nameFileOut
        }
        this.items.push(result)
      }
    },
    updateList(list) {
      this.completeList = list
    }
  }
}
</script>
